import React, { useCallback, useEffect, useState } from "react";
import classes from "./OrderStatus.module.css";
import { useSelector } from "react-redux";
import { initialTableData } from "../lib/InitialOrderStatus";
import useLang from "../hooks/useLang";
import { getUserRoleFromToken } from "../utils/Auth";
import { userRoles } from "../types/enums";
import { CONFIG } from "../config";

type OrderStatusProps = {
	orderData?: any[];
	descProp?: string;
	numberProp?: string;
	sticky?: boolean;
	stickyTop?: string;
};

const FinanceStatistic: React.FC<OrderStatusProps> = ({
	orderData,
	descProp,
	numberProp,
	sticky = false,
	stickyTop = "0px",
}) => {
	const [userRole, setUserRole] = useState<any | undefined>();
	const reduxData = useSelector(
		(state: any) => state.finance.companyFinanceData
	);
	useEffect(() => {
		const userRoleId = getUserRoleFromToken();
		setUserRole(userRoleId);
	}, []);

	const { strings } = useLang("financeStatistics");
	const orderData1 = [
		{
			description: strings?.descriptions.currentBalance,
			amount: `${
				reduxData?.currentBalance ?? (0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.salesBalance,
			amount: `${
				reduxData?.salesBalance ?? (0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.refusals,
			amount: `${
				reduxData?.refusals ?? (0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.totalBalance,
			amount: `${
				reduxData?.totalBalance ?? (0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.currentUnsettled,
			amount: `${
				reduxData?.currentUnsettled ?? (0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
	];
	const orderData2 = [
		{
			description: strings?.descriptions.orderPackagePrice,
			amount: `${
				reduxData?.orderPackagePrice?.toFixed(2) ?? (0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.transportPrice,
			amount: `${
				reduxData?.transportPrice?.toFixed(2) ?? (0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.refusalOrderPackagePrice,
			amount: `${
				reduxData?.refusalOrderPackagePrice?.toFixed(2) ??
				(0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.processedSettlementValues,
			amount: `${
				reduxData?.processedSettlementValues?.toFixed(2) ??
				(0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.allExpenses,
			amount: `${
				reduxData?.allExpenses?.toFixed(2) ?? (0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.currentCash,
			amount: `${
				reduxData?.currentCash?.toFixed(2) ?? (0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
		{
			description: strings?.descriptions.unConfirmedSettlementValues,
			amount: `${
				reduxData?.unConfirmedSettlementValues?.toFixed(2) ??
				(0.0).toFixed(2)
			}${CONFIG?.CURRENCY}`,
		},
	];

	return (
		<>
			<div
				className={classes.financeStatusContainer}
				style={{
					position: sticky ? "sticky" : "static",
					top: sticky ? stickyTop : "auto",
					zIndex: sticky ? 100 : "auto",
				}}
			>
				<div className={classes.firstStatusForFinance}>
					<div className={classes.mainStatusForFinance}>
						{userRole === userRoles.CLIENT
							? orderData1.map((data: any, index: number) => (
									<div
										className={`${classes.oneDiv} ${
											index === orderData1.length - 1
												? `${classes.noBorder}`
												: ""
										}`}
										key={index}
									>
										<p className={classes.statusDesc}>
											{data["description"]}
										</p>
										<h1 className={classes.statusNumber}>
											{data["amount"]}
										</h1>
									</div>
							  ))
							: orderData2.map((data: any, index: number) => (
									<div
										className={`${classes.oneDiv} ${
											index === orderData2.length - 1
												? `${classes.noBorder}`
												: ""
										}`}
										key={index}
									>
										<p className={classes.statusDesc}>
											{data["description"]}
										</p>
										<h1 className={classes.statusNumber}>
											{data["amount"]}
										</h1>
									</div>
							  ))}
					</div>
				</div>
			</div>
		</>
	);
};

export default FinanceStatistic;
